<template>
  <div class="file-slide-media p-1">
    <FMFileViewerError v-if="error != null || imageLoadFailed" />
    <img
      v-else-if="url != null"
      :src="url"
      :class="{
        'recently-change': recentlyChanged,
        'preview-image-shadow': !bigShadow,
        'preview-image-shadow-big': bigShadow,
      }"
      @error="imageLoadFailed = true"
    />
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { useMinioSignedUrl } from "@/functions/useMinioSignedUrl";
import FMFileViewerError from "./FMFileViewerError.vue";

const props = defineProps({
  fileUUID: {
    type: String,
    required: true,
  },
  recentlyChanged: {
    type: Boolean,
    required: false,
    default: false,
  },
  bigShadow: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const { url, error } = useMinioSignedUrl(computed(() => props.fileUUID));
const imageLoadFailed = ref(false);

watch(url, () => {
  imageLoadFailed.value = false;
});
</script>

<style lang="scss" scoped>
@use "@/modules/filemanagement/components/FMFileViewer/FMFileViewer.scss" as *;

.file-slide-media {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  min-height: 0;
}

img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
  display: block;
}
</style>
